import React, { Component } from 'react'
import { find, propEq } from 'ramda'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Button } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import './style.css'

const APP_CATEGORY_OPTIONS = [
  { label: 'Communication', value: 'COMMUNICATION' },
  { label: 'CRM', value: 'CRM' },
  { label: 'Enrichment', value: 'ENRICHMENT' },
  { label: 'Analytics', value: 'ANALYTICS' },
  { label: 'Support', value: 'SUPPORT' }
]

const APP_PRICING_OPTIONS = [
  { label: 'Free', value: 'FREE' },
  { label: 'Freemium (some features free)', value: 'FREEMIUM' },
  { label: 'Paid', value: 'PAID' }
]

class DisplayInformationContent extends Component {
  static propTypes = {
    appId: PropTypes.string.isRequired,
    category: PropTypes.string,
    paidStatus: PropTypes.string,
    onCategoryUpdated: PropTypes.func.isRequired,
    onPricingUpdated: PropTypes.func.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    selectedCategoryValue: null,
    selectedPricingValue: null
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedCategoryValue: props.category,
      selectedPricingValue: props.paidStatus
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ selectedCategoryValue: props.category, selectedPricingValue: props.paidStatus })
  }

  selectCategorySelected = ({ value }) => {
    const { selectedCategoryValue } = this.state
    const { showErrorNotification } = this.props

    const onError = () => {
      showErrorNotification('Oops, we couldn’t update the category. Please try again later.')
      this.setState({ selectedCategoryValue })
    }

    const onStateSet = () => this.props.onCategoryUpdated(value).catch(onError)

    this.setState({ selectedCategoryValue: value }, onStateSet)
  }


  selectPricingSelected = ({ value }) => {
    const { selectedPricingValue } = this.state
    const { showErrorNotification } = this.props

    const onError = () => {
      showErrorNotification('Oops, we couldn’t update the pricing model. Please try again later.')
      this.setState({ selectedPricingValue })
    }

    const onStateSet = () => this.props.onPricingUpdated(value).catch(onError)

    this.setState({ selectedPricingValue: value }, onStateSet)
  }

  render() {
    const { selectedCategoryValue, selectedPricingValue } = this.state
    const { history, appId } = this.props

    return (
      <div className="app-submit-view-accordion-content">
        <p className="app-submit-view-accordion-content-description">
          Make sure your app is fully set up with: an app name, logo, short description and a long description. That way others will be able to easily find and understand what your app does when they go to install it.
        </p>
        <Select
          className="app-submit-display-information-select"
          searchable={false}
          clearable={false}
          options={APP_CATEGORY_OPTIONS}
          label="App Category"
          value={find(propEq('value', selectedCategoryValue), APP_CATEGORY_OPTIONS)}
          description="Choose which category you would like your app to show up in."
          onChange={this.selectCategorySelected}
        />

        <Select
          className="app-submit-display-information-select"
          searchable={false}
          clearable={false}
          options={APP_PRICING_OPTIONS}
          label="Paid Status"
          value={find(propEq('value', selectedPricingValue), APP_PRICING_OPTIONS)}
          description="Select the pricing for your app. Note that collecting payment for any freemium or paid app must be managed by you."
          onChange={this.selectPricingSelected}
        />
        <Button
          className="app-submit-display-information-button"
          type="secondary"
          size="small"
          onClick={() => history.push(`/app/${appId}/info`)}>
          View Display Information
        </Button>
      </div>
    )
  }
}

export default withRouter(DisplayInformationContent)
